import { EthInput } from "@dzambalaorg/mui-inputs-mask";

export { amountValidationSchema } from "./validation";

export interface IAmountDto {
  amount: number;
}

export const AmountDialog = () => {
  return <EthInput name="amount" units={0} symbol="" />;
};
